var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666748,
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#FFFAEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 41.3335C36.6667 38.388 33.085 36.0002 28.6667 36.0002C24.2485 36.0002 20.6667 38.388 20.6667 41.3335M36.6667 33.3335H44.6667M28.6667 32.0002C25.7212 32.0002 23.3334 29.6123 23.3334 26.6668C23.3334 23.7213 25.7212 21.3335 28.6667 21.3335C31.6123 21.3335 34.0001 23.7213 34.0001 26.6668C34.0001 29.6123 31.6123 32.0002 28.6667 32.0002Z",
    stroke: "#B54708",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveEmployees);
export default __webpack_public_path__ + "static/media/Inactive Employees.5eaaa3c3c09e94432499a979346b6fe9.svg";
export { ForwardRef as ReactComponent };